/* ============================================
   MAISON LÉONIE — Theme JS
   ============================================ */

// --- Header scroll effect ---
(function() {
  const header = document.getElementById('site-header');
  if (!header) return;
  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    lastScroll = currentScroll;
  });
})();

// --- Hero slider with dots ---
(function() {
  const slides = document.querySelectorAll('.hero-slide');
  if (slides.length <= 1) return;

  const dotsContainer = document.getElementById('hero-dots');
  let current = 0;
  let timer;
  const duration = 6000;

  // Create dots
  if (dotsContainer) {
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', () => { clearInterval(timer); goTo(i); startTimer(); });
      dotsContainer.appendChild(dot);
    });
  }

  function goTo(n) {
    const dots = document.querySelectorAll('.hero-dot');
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }

  function startTimer() {
    timer = setInterval(() => goTo(current + 1), duration);
  }

  startTimer();
})();

// --- Cart Drawer ---
function openCartDrawer() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

// --- Refresh cart drawer via Section Rendering API ---
function refreshCartDrawer() {
  return fetch('/?sections=cart-drawer')
    .then(r => r.json())
    .then(data => {
      const wrapper = document.getElementById('shopify-section-cart-drawer');
      if (wrapper && data['cart-drawer']) {
        // Section API returns the full wrapper — extract inner content
        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        const inner = tmp.querySelector('#shopify-section-cart-drawer');
        wrapper.innerHTML = inner ? inner.innerHTML : data['cart-drawer'];
      }
      // Update header cart count if present
      return fetch('/cart.js').then(r => r.json()).then(cart => {
        const countEl = document.querySelector('.header-cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        }
      });
    });
}

// --- Quick Add to Cart (vignettes produits liés) ---
function quickAdd(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(() => refreshCartDrawer())
  .then(() => openCartDrawer())
  .catch(() => { window.location.href = '/cart'; });
}

// --- Intercept main product form submit (fix critique 14/04/26) ---
document.addEventListener('submit', function(e) {
  const form = e.target;
  if (!form.classList || !form.classList.contains('shopify-product-form')) return;
  e.preventDefault();
  const btn = form.querySelector('.add-to-cart-btn, [type="submit"]');
  const original = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
  fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
    .then(r => r.json().then(j => ({ ok: r.ok, body: j })))
    .then(({ ok, body }) => {
      if (!ok) throw new Error(body.description || 'add failed');
      return refreshCartDrawer();
    })
    .then(() => {
      if (btn) { btn.disabled = false; btn.textContent = original; }
      openCartDrawer();
    })
    .catch(err => {
      if (btn) { btn.disabled = false; btn.textContent = original; }
      console.error('Cart add failed:', err);
      window.location.href = '/cart';
    });
});

// --- Update Cart Item ---
function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(res => res.json())
  .then(() => refreshCartDrawer());
}

// --- Product Options ---
function selectOption(btn) {
  const siblings = btn.parentElement.querySelectorAll('.size-btn');
  siblings.forEach(s => s.classList.remove('selected'));
  btn.classList.add('selected');

  // Update variant based on selected options
  const selectedOptions = [];
  document.querySelectorAll('.size-btn.selected').forEach(s => {
    selectedOptions.push(s.dataset.value);
  });

  // Find matching variant
  if (window.productVariants) {
    const variant = window.productVariants.find(v => {
      return v.options.every((opt, i) => !selectedOptions[i] || opt === selectedOptions[i]);
    });
    if (variant) {
      document.getElementById('product-variant-id').value = variant.id;
      const priceEl = document.querySelector('.product-price');
      if (priceEl) {
        priceEl.textContent = (variant.price / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }
  }
}

// --- Accordion ---
function toggleAccordion(trigger) {
  const content = trigger.nextElementSibling;
  const isOpen = trigger.classList.contains('open');

  // Close all
  document.querySelectorAll('.accordion-trigger').forEach(t => {
    t.classList.remove('open');
    t.nextElementSibling.style.maxHeight = null;
  });

  // Open clicked if was closed
  if (!isOpen) {
    trigger.classList.add('open');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
}

// --- Fade in on scroll ---
(function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
})();
